module.exports = __webpack_public_path__ + "img/9788954428293.74a64b72.jpg";